<template>
  <div id="form-disponibilidad" class="row">
    <div class="col-md-12">
      <div class="titulo-seccion m-t-none">
        {{ $I18n.t('disponibilidad_para_guardias') }}
      </div>
      <div class="row form-group">
        <div class="col-sm-12">
          <label for="" class="control-label">{{ $I18n.t('Usuario') }}</label>
          <selector-usuario
            v-model="usuarioId"
            :deshabilitado="disabled"
            :icon="true"
            :precargar="true"
            :activos="true"
            tipo="profesor"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="" class="control-label">{{ $I18n.t('Fecha_inicio') }}</label>
            <div>
              <input-fecha-hora
                v-model="fechaInicio"
                :disabled="disabled"
                :timepicker="true"
              />
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="" class="control-label">{{ $I18n.t('Fecha_fin') }}</label>
            <div>
              <input-fecha-hora
                v-model="fechaFin"
                :disabled="disabled"
                :timepicker="true"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="puedeRepetir" class="row form-group">
        <div class="col-sm-6">
          <input-checkbox-boolean
            v-model="repetirSemanalmente"
            :disabled="disabled"
          >
            {{ $I18n.t('Repetir_semanalmente') }}
          </input-checkbox-boolean>
        </div>
        <div class="col-sm-6">
          <input-fecha-hora
            v-if="repetirSemanalmente"
            v-model="fechaFinRepeticion"
            :disabled="disabled"
          />
        </div>
      </div>
      <div class="form-actions">
        <boton-eliminar-evento
          v-if="!disabled && disponibilidadId"
          :evento-id="disponibilidadId"
          :uuid-repeticion="uuidRepeticion"
          class="pull-left"
          @confirmado="eliminar"
        />
        <button class="btn btn-default" @click.prevent="$emit('cancelado')">
          {{ labelCancelar }}
        </button>
        <boton-guardar
          v-if="!disabled"
          :submitting="guardando"
          :disabled="!puedeGuardar"
          @click="guardar"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { addHours } from 'date-fns';
import disponibilidades from '../../../api/cifra/guardias/disponibilidades';
import { showApiErrors } from '../../../libs/cifra/flash';
import Overlay from '../../../libs/cifra/overlay';
import toast from '../../../libs/cifra/toast';
import BotonEliminarEvento from '../../../components/cifra/BotonEliminarEvento.vue';
import { localISODateTimeString } from '../../../libs/dates';

export default {
  components: { BotonEliminarEvento },
  props: {
    disponibilidadId: { type: Number, default: null },
    disabled: { type: Boolean, default: false },
    puedeCambiarUsuario: { type: Boolean, default: true },
    fechaInicioInicial: { type: Date, default: null },
    fechaFinInicial: { type: Date, default: null },
    fechaFinRepeticionInicial: { type: Date, default: null },
  },
  data() {
    let fechaInicio;
    if (this.fechaInicioInicial) {
      fechaInicio = this.fechaInicioInicial;
    } else {
      fechaInicio = new Date();
      fechaInicio.setMinutes(0, 0, 0);
    }

    const fechaFin = this.fechaFinInicial || addHours(fechaInicio, 1);

    return {
      fechaInicio: localISODateTimeString(fechaInicio),
      fechaFin: localISODateTimeString(fechaFin),
      repetirSemanalmente: false,
      fechaFinRepeticion: this.fechaFinRepeticionInicial,
      uuidRepeticion: null,
      usuarioId: null,
      cargando: false,
      guardando: false,
    };
  },
  computed: {
    puedeGuardar() {
      let ok = this.usuarioId && this.fechaInicio && this.fechaFin;
      if (this.repetirSemanalmente) {
        ok = ok && this.fechaFinRepeticion;
      }
      return ok;
    },
    puedeRepetir() {
      return !this.edicion;
    },
    edicion() {
      return !!this.disponibilidadId;
    },
    labelCancelar() {
      return this.$I18n.t(this.disabled ? 'Cerrar' : 'Cancelar');
    },
  },
  watch: {
    fechaInicio() {
      if (this.fechaInicio && !this.cargando) {
        this.fechaFin = localISODateTimeString(addHours(new Date(this.fechaInicio), 1));
      }
    },
  },
  mounted() {
    if (this.disponibilidadId) {
      this._cargarDisponibilidad();
    }
  },
  methods: {
    guardar() {
      if (this.disabled) {
        return;
      }

      this.guardando = true;
      const overlay = new Overlay(this.$el);
      overlay.show();

      const fechaInicio = new Date(this.fechaInicio);
      const fechaFin = new Date(this.fechaFin);

      disponibilidades.save({
        disponibilidad: {
          id: this.disponibilidadId,
          usuario_id: this.usuarioId,
          fecha_inicio: fechaInicio,
          fecha_fin: fechaFin,
          tipo_repeticion: this.repetirSemanalmente ? 'semanal' : null,
          fecha_fin_repeticion: this.fechaFinRepeticion,
        },
      }).then((result) => {
        this.guardando = false;
        overlay.hide();
        toast.success(this.$I18n.t('guardado_correcto'));
        this.reset();
        this.$emit('guardado', result);
      }).catch((result) => {
        this.guardando = false;
        overlay.hide();
        showApiErrors(result);
      });
    },
    eliminar(confirmData) {
      this.guardando = true;
      const overlay = new Overlay(this.$el);
      overlay.show();
      disponibilidades.destroy(this.disponibilidadId, confirmData.tipoBorrado).then((result) => {
        this.guardando = false;
        overlay.hide();
        toast.success(this.$I18n.t('registro_eliminado_correctamente'));
        this.reset();
        this.$emit('eliminado', result);
      }).catch((result) => {
        this.guardando = false;
        overlay.hide();
        showApiErrors(result);
      });
    },
    reset() {
      this.fechaInicio = null;
      this.fechaFin = null;
      this.usuarioId = null;
      this.uuidRepeticion = null;
    },
    _cargarDisponibilidad() {
      this.cargando = true;
      disponibilidades.get(this.disponibilidadId).then((result) => {
        const { data } = result;
        this.fechaInicio = localISODateTimeString(new Date(data.fecha_inicio));
        this.fechaFin = localISODateTimeString(new Date(data.fecha_fin));
        this.uuidRepeticion = data.uuid_repeticion;
        this.usuarioId = data.usuario.id;
        this.$nextTick(() => { this.cargando = false; });
      });
    },
  },
};
</script>
